export { SpaClassListTemplate } from './SpaClassListTemplate';
export type {
  SpaClassListCategoryOption,
  SpaClassListItem,
  SpaClassListTemplateProps,
} from './SpaClassListTemplate.types';
